import { render, staticRenderFns } from "./company-metadata-fee-overview.vue?vue&type=template&id=62d64976&scoped=true&lang=pug"
import script from "./company-metadata-fee-overview.vue?vue&type=script&lang=ts"
export * from "./company-metadata-fee-overview.vue?vue&type=script&lang=ts"
import style0 from "./company-metadata-fee-overview.vue?vue&type=style&index=0&id=62d64976&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d64976",
  null
  
)

export default component.exports